import type { Edge2dComputed, Face2dComputed } from "."
import { makeTinyOffsets } from "./makeTinyOffsets"
import { doesPolygon } from "../2d/collision"
import { createNormalFn } from "../2d/createNormalFn"
import { findMidpoint } from "../2d/findMidpoint"
import { findAngle } from "../2d/findOffsetAngle"
import { edgeToLinearFn } from "../2d/transmute"

type AngleFromPolygonEdge = (
  edge: Edge2dComputed,
  face: Face2dComputed,
  direction?: `inside` | `outside`,
) => number

export const angleFromPolygonEdge: AngleFromPolygonEdge = (
  edge,
  face,
  direction = `outside`,
): number => {
  // const { p1, p2 } = edge
  const midpoint = findMidpoint(edge)
  const linearFn = edgeToLinearFn(edge)
  const normalFn = createNormalFn(linearFn, midpoint)
  const points = makeTinyOffsets(midpoint, normalFn)
  for (const point of points) {
    const isInPolygon = doesPolygon(face).containPoint(point)
    const shouldBeInPolygon = direction === `inside`
    if (isInPolygon === shouldBeInPolygon) {
      const angle = findAngle(midpoint, point)

      return angle
    }
  }
  throw new Error(
    `Unexpected result from getAngle, neither point was ${direction} the polygon.`,
  )
}

export const angleInto = (
  face: Face2dComputed,
): { from: (edge: Edge2dComputed) => number } => ({
  from: (edge) => angleFromPolygonEdge(edge, face, `inside`),
})

export const angleOutOf = (
  face: Face2dComputed,
): { from: (edge: Edge2dComputed) => number } => ({
  from: (edge) => angleFromPolygonEdge(edge, face, `outside`),
})
